import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {inches, lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

export class FrameProfileSTD extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // the bottom rabbet — the mirror of the primary about the centre stop. STD is
    // symmetric, so an item can mount on either rabbet; balancedMountAnchors picks.
    secondaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, clamshell, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:STD:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";

        if (!left) shape.invertX();
        if((!swingIn) !== !!flipY) shape.invertY();

        // |----|
        //      |
        //      |
        //      ----|
        //          |
        //          |
        //      ----|
        //      |
        // |----|

        // debug
        /*
        const label = new BitmapText(left ? "L" : "R", {fontName: "Arial", fontSize: 12});
        label.anchor.set(0.5, 0.5);
        label.tint = 0x000000;
        this.lines.addChild(label);
        */

        const returnV = 0.638 * inches;  // top return, vertical

        shape.start(0, 0);
        const startPoint = shape.lineTo(0, -returnV);
        if(clamshell) startPoint.setPenUp();
        else startPoint.linkDimension(detail.topTab, "extended");

        const topFace = shape.lineTo(10, 0);

        // rabbet
        const rabbet = shape.lineTo(0, 20);
        shape.addDimension(rabbet.pointA, rabbet.pointB, detail.rabbetDepth);
        this.primaryDoorAnchor.setLocalPoint(rabbet.pointB);

        // shape.flagForDebug(rabbet.pointB, "ANC");

        const indent = shape.lineTo(20, 0);
        shape.lineTo(0, 40);

        const indentRef = shape.lineTo(-20, 0);
        indentRef.dimMatches(indent);

        // bottom rabbet
        const bottomRabbet = shape.lineTo(0, 20);
        shape.addDimension(bottomRabbet.pointA, bottomRabbet.pointB, detail.bottomRabbetDepth);
        // the mounting corner is the one nearest the centre stop — the mirror of the
        // primary's rabbet.pointB.
        this.secondaryDoorAnchor.setLocalPoint(bottomRabbet.pointA);

        const bottomFace = shape.lineTo(-10, 0);
        const bottomReturn = shape.lineTo(0, -returnV);
        if(clamshell) bottomReturn.setPenUp();
        else bottomReturn.linkDimension(detail.bottomTab, "extended");

        bottomFace.dimMatches(topFace);
        bottomFace.linkDimension(jambFace);

        shape.addDimension(startPoint.pointB, bottomFace.getEndpoint(), jambDepth);

        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}